export default {
  title: 'Планово-предупредительный ремонт'
}